<template>
    <div class="row" id="ajuda">
        <h6 class="col-12">Como podemos ajudar?</h6>
        <div class="col-12">
            <BotaoVerMais :classes="'w-100 text-left mb-3'" 
                :id="'abrir-contato'"
                :target="'contato'"
                :textoAbrir="'Quero contato com a assistência'" 
                :textoFechar="'Quero contato com a assistência'"
                @acaoVerMais="abrirTipoContato" 
            />
            <div id="contato" style="display: none;">
                <div class="row">
                    <div class="col-12 mb-2 text-center">
                        <a :href="tratarUrl()" role="button" class="btn btn-success m-1"
                            v-if="!isEmpty(whatsappContato)" target="_blank">
                            Whatsapp <i class="fab fa-whatsapp "></i>
                        </a>
                        <a :href="`tel:${telefoneContato}`" role="button" class="btn btn-primary m-1"
                            v-if="!isEmpty(telefoneContato)" v-b-popover.hover.top="`Ligar para ${telefoneContato}`"
                            target="_blank">
                            Ligar <span class="material-symbols-outlined">call</span>
                        </a>
                    </div>
                    <div class="col-12 mb-2">
                        <div v-if="!isEmpty(whatsappContato) || !isEmpty(telefoneContato)">
                            ou envie uma mensagem...
                        </div>
                        <textarea id="mensagem-contato" name="mensagemContato" rows="5" class="w-100"
                            v-model="mensagemContato" placeholder="Escreva uma mensagem...">
                        </textarea>

                    </div>
                    <div class="col-12 text-end">
                        <button type="button" class="btn btn-warning text-white" @click="enviarContato(false)"
                            :disabled="loading">
                            {{ loading ? 'Aguarde ...' : 'Enviar' }}
                            <span class="material-symbols-outlined">send</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 mt-2">
            <BotaoVerMais :classes="'w-100 text-left mb-3'" 
                :id="'abrir-cancelar'"
                :target="'cancelar'"
                :textoAbrir="'Quero cancelar o meu atendimento'" 
                :textoFechar="'Quero cancelar o meu atendimento'"
                @acaoVerMais="abrirTipoContato"
             />
            <div id="cancelar" style="display: none;">
                <div class="col-12 mb-2">
                    <textarea id="mensagem-cancelamento" name="mensagemCancelamento" rows="5" class="w-100"
                        v-model="mensagemCancelamento" placeholder="Nos conte o motivo...">
                    </textarea>
                </div>
                <div class="col-12 text-center">
                    <button type="button" class="btn btn-danger text-white" @click="enviarContato(true)"
                        :disabled="loading">
                        {{ loading ? 'Aguarde ...' : 'Cancelar serviço' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import BotaoVerMais from "@/components/Botoes/BotaoVerMais.vue";
import { computed, ref } from 'vue';
import { isEmpty } from "@/helper/funcoes";
import { toast, alert, confirm } from "@/helper/alerts";
import { storeToRefs } from 'pinia';
import { useAtendimentoStore } from '@/stores/atendimento';
import { slideDown, slideUp } from '@/helper/funcoes';

const storeAtendimento = useAtendimentoStore();
const { atendimento } = storeToRefs(storeAtendimento);

const mensagemContato = ref('');
const mensagemCancelamento = ref('');
let loading = ref(false);
const mostrarMais = ref({ contato: false, cancelar: false });

const telefoneContato = computed(() => atendimento.value.telefoneContato || '');
const whatsappContato = computed(() => atendimento.value.whatsappContato || '');

function abrirTipoContato(target) {
    if (target) {
        mostrarMais.value[target] = !mostrarMais.value[target];
        const elemento = document.getElementById(target)
        if (mostrarMais.value[target]) {
            slideDown(elemento, 300);
        } else {
            slideUp(elemento, 300);
        }
    }
}

function enviarContato(cancelamento) {
    try {
        loading.value = true;
        if (validarMensagemContato(cancelamento)) {
            const { tipoSolicitacao, mensagem } = tratarMensagemContato(cancelamento);
            confirm(`Confirma o envio da <b>solicitação de ${tipoSolicitacao}</b>`, '', async () => {
                loading.value = true;
                if (atendimento.value.enviarContatoWhatsapp == 'S' && !isEmpty(atendimento.value.whatsappContato)) {
                    enviarWhatsapp(mensagem);
                } else {
                    const response = await storeAtendimento.solicitarContato(mensagem, cancelamento);
                    toast("success", response.message);
                }

                mensagemContato.value = '';
                mensagemCancelamento.value = '';
                loading.value = false;
            });
        }
    } catch (error) {
        alert('error', '', error.message);
    } finally {
        loading.value = false;
    }
}

function validarMensagemContato(cancelamento) {
    if (
        (cancelamento && isEmpty(mensagemCancelamento.value)) ||
        (!cancelamento && isEmpty(mensagemContato.value))
    ) {
        alert('info', '', "A mensagem é obrigatória");
        return false;
    }

    return true;
}

function tratarMensagemContato(cancelamento) {
    let tipoSolicitacao = 'contato';
    let mensagem = '';
    if (cancelamento === true) {
        tipoSolicitacao = 'cancelamento';
        mensagem += `O solicitante deseja fazer o <b>cancelamento</b> do serviço. <br><br>`;
        mensagem += mensagemCancelamento.value.replace(/\r?\n/g, '<br>');
    } else {
        mensagem += mensagemContato.value.replace(/\r?\n/g, '<br>');
    }
    return { tipoSolicitacao, mensagem };
}

function enviarWhatsapp(mensagem) {
    const array = atendimento.value.whatsappContato.split('&text=');
    let url = array[0];
    if (array.length == 2) {
        mensagem = mensagem.replace('<br>', '\n').replace(/<[^>]*>?/gm, '');
        url += `&text=${encodeURIComponent(mensagem)}`;
        window.open(url);
    }
}

function tratarUrl() {
    if (isEmpty(atendimento.value.whatsappContato)) {
        return '';
    }

    const array = atendimento.value.whatsappContato.split('&text=');
    let url = array[0];
    if (array.length == 2) {
        url += `&text=${encodeURIComponent(array[1])}`;
    }
    return url;
}
</script>